import { useMutation, useQueryClient } from '@tanstack/react-query';
import { vendorBroadcastApi, vendorBroadcastKeys } from '@/entities/vendor-broadcast';

/**
 * Mark a batch of broadcasts viewed — fired once when the drawer or the
 * fresh-items dialog opens with unseen items. The badge count drops on the
 * invalidation, not optimistically: a failed batch must not hide the badge.
 */
export function useMarkBroadcastsViewed() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ids: number[]) =>
      Promise.all(ids.map((id) => vendorBroadcastApi.markViewed(id))),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: vendorBroadcastKeys.all });
    },
  });
}
